/* jshint undef: true, unused: true */
/* globals define, jQuery */

  var me = require('./me');

  function isElement(object) {
    return object instanceof Element || object instanceof HTMLDocument;
  }

  module.exports = function translation(domain) {
    var translations;

    function translateForm(obj) {
      for (var prop in obj) {

        if (obj.hasOwnProperty(prop) && isElement(obj[prop]) === false) {

          var translation;

          if (typeof obj[prop] === 'object'){

            obj[prop] = translateForm(obj[prop], translations);

          } else {

            if (prop === 'html') {
              var re = new RegExp(domain + '\.[A-Z0-9\._]*', 'gi');
              var i,
                  strings = obj[prop].match(re);

              if (!strings) {
                continue;
              }

              for(i = 0; i < strings.length; i++) {

                var loopTranslation = translations[strings[i]];

                if (loopTranslation) {
                  obj[prop] = obj[prop].replace(strings[i], loopTranslation);
                } else {
                  console.log('no translation found for ' + strings[i]  + ' in ' + obj[prop]);
                }
              }

            } else {
              translation = translations[obj[prop]];

              if (translation) {
                obj[prop] = translation;
              } else {
                // console.log('no translation found for ' + obj[prop]);
              }
            }
          }

        }
      }
      return obj;
    }

    function translateString(string) {
      var translation = translations && translations[string];

      return translation || string;
    }

    function getTranslations() {
      return new Promise(function (resolve, reject) {
        jQuery(function(){
          me.getLocale()
            .then(function(locale) {
              jQuery.ajax({url: '/api/public/i18n/' + domain + '/' + locale})
                .done(function(translationResults) {
                  translations = translationResults;

                  return resolve(translations);
                })
                .fail(reject);
            })
            .catch(reject);
        });
      });
    }

    return {
      getTranslations : getTranslations,
      translateForm   : translateForm,
      translateString : translateString,
      translations    : translations
    };
  };
